import { ProcessMenu } from './menu-processing'
const menu = [
  [
    {
      title: 'System',
      id: 'System-72',
      type: 'group',
      children: [
        {
          title: 'People',
          id: 'People-75',
          type: 'collapse',
          claim: 'Player',
          children: [
            {
              title: 'Players',
              id: 'Players-73',
              paths: ['/:id', '/'],
              hidden: false,
              targetView: 'Players',
              type: 'item',
            },
            {
              title: 'Invite Content Creator',
              id: 'Invite Content Creator-74',
              paths: ['/'],
              hidden: false,
              targetView: 'ContentCreatorInvite',
              type: 'item',
            },
          ],
          script: '',
        },
        {
          title: 'Media',
          id: 'Media-84',
          type: 'collapse',
          claim: 'Player',
          children: [
            {
              title: 'Media Approvals',
              id: 'Media Approvals-76',
              paths: ['/'],
              hidden: false,
              targetView: 'ApprovalRequests',
              type: 'item',
            },
            {
              title: 'Curated Series',
              id: 'Curated Series-77',
              paths: ['/'],
              hidden: false,
              targetView: 'CuratedSeriesList',
              type: 'item',
            },
            {
              title: 'Curated Media',
              id: 'Curated Media-78',
              paths: ['/'],
              hidden: false,
              targetView: 'CuratedMediaList',
              type: 'item',
            },
            {
              title: 'Coherent Screens',
              id: 'Coherent Screens-79',
              paths: ['/'],
              hidden: false,
              targetView: 'CoherentScreens',
              type: 'item',
            },
            {
              title: 'Preview Consumer Home Page',
              id: 'Preview Consumer Home Page-80',
              paths: ['/', '/:id', '/:id/:component'],
              hidden: false,
              targetView: 'PreviewCoherentScreen',
              type: 'item',
            },
            {
              title: 'Processing Dashboard',
              id: 'Processing Dashboard-81',
              paths: ['/'],
              hidden: false,
              targetView: 'ProcessingdDashboard',
              type: 'item',
            },
            {
              title: 'Media Resources',
              id: 'Media Resources-82',
              paths: ['/', '/:id'],
              hidden: false,
              targetView: 'MediaResources',
              type: 'item',
            },
            {
              title: 'Customer Settings',
              id: 'Customer Settings-83',
              paths: ['/'],
              hidden: false,
              targetView: 'CustomerSettings',
              type: 'item',
            },
          ],
          script: '',
        },
        {
          title: 'Settings',
          id: 'Settings-86',
          type: 'collapse',
          claim: 'Player',
          children: [
            {
              title: 'System Settings',
              id: 'System Settings-85',
              paths: ['/'],
              hidden: false,
              targetView: 'SystemSettings',
              type: 'item',
            },
          ],
          script: '',
        },
        {
          title: 'Roles',
          id: 'Roles-88',
          type: 'collapse',
          claim: 'Player',
          children: [
            {
              title: 'Player Role Setup',
              id: 'Player Role Setup-87',
              paths: ['/:id', '/'],
              hidden: false,
              targetView: 'PlayerRole',
              type: 'item',
            },
          ],
          script:
            '(function checkAuthorization() : any {\n    if(isLoggedIn && claims && !claims?.player) {\n        navigate(`/${(Views.Home)}`, { replace: true });\n    }\n})();',
        },
      ],
    },
  ],
]
export default ProcessMenu(menu)
